import { TrendingUp } from "lucide-react";
import { useNavigate } from "react-router";

export const IndustryInsightsCard = () => {
  const navigate = useNavigate();
  const metrics = [
    {
      label: "Avg. Monthly Sales",
      yourValue: "Rs. 254k",
      industryValue: "$ 180k",
      percentage: 82
    },
    {
      label: "Customer Return Rate",
      yourValue: "62%",
      industryValue: "84%",
      percentage: 91
    },
    {
      label: "SMS Campaign Engagement",
      yourValue: "14%",
      industryValue: "35%",
      percentage: 82
    }
  ];

  return (
    <div
      onClick={() => navigate("/campaigns/broadcast")}
      className="group relative p-6 rounded-[20px] bg-gradient-to-br from-white/90 to-white/70 backdrop-blur-sm border border-border/50 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgba(18,128,121,0.15)] transition-all duration-300 hover:scale-[1.03] cursor-pointer overflow-hidden"
    >
      {/* Hover glow effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      <div className="relative">
        <div className="flex items-center gap-2 mb-3">
          <span className="text-2xl">📈</span>
          <h3 className="text-sm font-medium text-muted-foreground">
            Industry Insights
          </h3>
        </div>

        <p className="text-lg font-semibold text-foreground mb-4">
          Here's how top businesses in your region are performing
        </p>

        {/* Comparison bars */}
        <div className="space-y-4 mb-4">
          {metrics.map((metric, index) => (
            <div
              key={metric.label}
              className="animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex justify-between text-xs mb-2">
                <span className="text-muted-foreground font-medium">
                  {metric.label}
                </span>
                <div className="flex gap-3">
                  {/* <span className="text-primary font-medium">
                    You: {metric.yourValue}
                  </span> */}
                  <span className="text-muted-foreground">
                    {metric.industryValue}
                  </span>
                </div>
              </div>
              <div className="relative h-2.5 bg-muted/30 rounded-full overflow-hidden">
                {/* Your performance bar */}
                <div
                  className="absolute h-full bg-gradient-to-r from-primary to-primary/80 rounded-full transition-all duration-500"
                  style={{ width: `${metric.percentage}%` }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Insight footer */}
        <div className="flex items-start gap-2 p-3 rounded-xl bg-primary/10 border border-primary/20">
          <TrendingUp className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
          <p className="text-xs text-foreground leading-relaxed">
            <span className="font-semibold">Tip:</span> Try targeted offers for
            your frequent visitors to close the gap!
          </p>
        </div>
      </div>
    </div>
  );
};
